import { Sprout, Gauge, Trophy } from "lucide-react";

// SINGLE SOURCE OF TRUTH for subscription plans.
// Rendered on the public Landing page (PricingModel) AND the logged-in upgrade page
// (ChoosePlan) so the two can never drift apart.
// Mark a feature `soon: true` when it's advertised but NOT yet built — the UI shows a
// "Coming soon" badge instead of a checkmark.

const RED = "#C8000F";
const GOLD = "#E6B35A";

export const CORE_PLANS = [
  {
    id: "rookie", name: "Rookie", icon: Sprout, price: "Free", unit: "",
    tag: "Start Rodeoing", accent: "#9AA1AB",
    desc: "For casual competitors who want Rodeo's basic tools.",
    features: [
      { label: "Find rodeos + dates & schedules" },
      { label: "Entry open & close dates" },
      { label: "View draws already in Rodeo" },
      { label: "Watch available draw videos", soon: true },
      { label: "Basic competitor results & stats" },
      { label: "Follow 1 competitor" },
    ],
    credits: [
      "Prepared entry — 1 credit each",
      "Draw lookup — 1 credit each",
      "Results & standings audit — 50 credits",
      "Extra competitor — 1 credit / month",
    ],
  },
  {
    id: "semi_pro", name: "Semi Pro", icon: Gauge, price: "$14.99", unit: "/mo", yearly: "$149/yr",
    tag: "Run Your Rodeo Season", accent: RED, popular: true,
    desc: "Spend less time organizing and more time competing.",
    features: [
      { label: "Everything in Rookie, plus:", head: true },
      { label: "Build your complete rodeo schedule" },
      { label: "Track where you're entered" },
      { label: "Official rodeo count tracking" },
      { label: "Entry deadline tracking" },
      { label: "Winnings tracking" },
      { label: "Season & performance goals" },
      { label: "Advanced planning tools" },
      { label: "Follow up to 5 competitors" },
    ],
    credits: [
      "2 prepared entries / mo (30 / yr)",
      "2 draw lookups / mo (30 / yr)",
      "Audit — 30 credits (20 / yr)",
      "Extra entries / lookups — 1 credit each",
    ],
  },
  {
    id: "professional", name: "Professional", icon: Trophy, price: "$29.99", unit: "/mo", yearly: "$299/yr",
    tag: "Next-Level Rodeo", accent: GOLD,
    desc: "For serious competitors who want Rodeo working for them all season.",
    features: [
      { label: "Everything in Semi Pro, plus:", head: true },
      { label: "Unlimited prepared entries" },
      { label: "Unlimited draw lookups" },
      { label: "Live, unlimited results & standings audit" },
      { label: "Follow up to 15 competitors" },
      { label: "AI Coach + personalized insights" },
      { label: "Advanced performance tools", soon: true },
    ],
    credits: ["No individual audits needed — your season stays audited automatically, all season."],
  },
];

export const SPECTATOR_PLANS = [
  { id: "fan", name: "Fan", price: "$2.99", desc: "Follow up to 3 competitors.",
    extra: "Additional competitors: 1 credit / competitor / month" },
  { id: "plus", name: "Plus", price: "$5.99", desc: "Follow up to 10 competitors.",
    extra: "Additional competitors: 1 credit / competitor / month", popular: true },
  { id: "all_access", name: "All Access", price: "$9.99", desc: "Follow unlimited competitors.",
    extra: "Built for serious fans who follow the whole season." },
];
